import React, { useState } from "react";
import { CardElement, StripeProvider, Elements, injectStripe } from "react-stripe-elements";
import { Formik, Form } from "formik";
// import * as Yup from "yup";
import { ClearButton } from "@components/common/atoms";
import { CheckboxField } from "@components/common/molecules";
import { useScript, useStoreAppValue } from "@hooks";
import { Bugsnag } from "@services";

// == Types ================================================================

interface IProps {
  setAddNewCard: (val: boolean) => void;
  onSaveNewCardClick: ({ token: $FixMe, saveCard: boolean }) => void;
}

interface IStripeForm extends IProps {
  stripe: $FixMe;
}

// == Constants ============================================================
CheckoutViewStripeFields.defaultProps = {};

const createOptions = () => {
  return {
    style: {
      base: {
        color: "#333",
        lineHeight: "40px",
        fontFamily: 'CerebriSans, "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "1rem",
        "::placeholder": {
          color: "#999",
        },
      },
      invalid: {
        color: "#a94442",
        iconColor: "#a94442",
      },
    },
  };
};

// == Component ============================================================

function StripeForm({ stripe, setAddNewCard, onSaveNewCardClick }: IStripeForm) {
  const [stripeError, setStripeError] = useState(null);
  const { currentUser } = useStoreAppValue();
  return (
    <Formik
      initialValues={{ saveCard: false }}
      onSubmit={async (values, { setSubmitting }) => {
        const { error, token } = await stripe.createToken();
        if (error) {
          setStripeError(error.message);
          Bugsnag.notify(error);
        } else {
          setStripeError(null);
          setAddNewCard(false);
          onSaveNewCardClick({ token, saveCard: values.saveCard });
        }
        setSubmitting(false);
      }}
    >
      <Form className="ElementsApp">
        <CardElement {...createOptions()} />
        {stripeError && <span className="standalone-error">{stripeError}</span>}
        {currentUser && <CheckboxField label="Save card after purchase" name="saveCard" />}
        <ClearButton type="submit" width="100%">
          Use This Card
        </ClearButton>
      </Form>
    </Formik>
  );
}

const InjectedStripeForm = injectStripe(StripeForm);

function CheckoutViewStripeFields(props: IProps) {
  const { stripeKey } = useStoreAppValue();
  const [loaded] = useScript("https://js.stripe.com/v3/");

  if (!loaded) return null;
  return (
    <StripeProvider apiKey={stripeKey}>
      <Elements>
        <InjectedStripeForm {...props} />
      </Elements>
    </StripeProvider>
  );
}

export default CheckoutViewStripeFields;

// == Styles ===============================================================
